export enum GroupExportColumns {
    financialEmailAddress = 'financialEmailAddress',
    identifierDeclaration = 'identifierDeclaration',
    name = 'name',
    organizations = 'organizations',
    relationNumber = 'relationNumber',
    status = 'status',
}
